module.exports = __webpack_public_path__ + "static/media/ACE-AAP-2019.f3b84da5.pdf";